import { FaTags } from 'react-icons/fa';
import { currencyFormat } from 'legacy/common/utils/currency';
import { Trans, useTranslation } from 'react-i18next';
import { OutgoingCheckoutSessionDiscountCodeDto } from 'api/dtos/products/checkout';

interface DiscountCodeBannerProps {
  discountCode: OutgoingCheckoutSessionDiscountCodeDto;
}

function DiscountCodeBanner({ discountCode }: DiscountCodeBannerProps) {
  const { t } = useTranslation(['checkout']);

  if (!discountCode) {
    return null;
  }

  return (
    <div className="w-full rounded-lg bg-primary-200 flex items-center p-4">
      <div className="text-xl">
        <FaTags />
      </div>
      <div className="flex flex-col ml-4">
        {discountCode?.discount ? (
          <>
            <div className="flex flex-row">
              <Trans
                i18nKey="checkout:discountCodeApplied"
                components={{
                  strong: <strong className="mr-1" />
                }}
                values={{ code: discountCode.code }}
              />
            </div>
            <div className="text-gray-400">
              {t('checkout:amountOff', {
                amount:
                  discountCode.discount.kind === 'amount'
                    ? currencyFormat(discountCode.discount.value)
                    : `${discountCode.discount.value}%`
              })}
            </div>
          </>
        ) : (
          <div className="flex flex-row">
            <Trans
              i18nKey="checkout:discountCodeApplied"
              components={{
                strong: <strong className="mr-1" />
              }}
              values={{ code: discountCode.code }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default DiscountCodeBanner;
